export default __webpack_public_path__ + "static/media/24-win a game.17b8ea5c.svg";